import React, { useState } from "react";
import Layout from "./Components/Common/Layout";
import TextField from "@mui/material/TextField";
import { Typography, Divider, Modal, Tabs, Input, Button, Space } from "antd";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

// SELECT
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// SELECT
////TABLA
import styled from "styled-components";
import { useTable, useSortBy, useFilters } from "react-table";
import { useExportData } from "react-table-plugins";
import Papa from "papaparse";
// import XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
// ESTILOS
import makeData from "./makeData";
// Instalar
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Pagination
import TablePagination from "@mui/material/TablePagination";
import { Option } from "antd/lib/mentions";

// DATEPICKER
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// DATEPICKER

import estadisticas1 from "./assets/estadisticas1.png";
import estadisticas2 from "./assets/estadisticas2.png";
import { CgBorderBottom } from "react-icons/cg";
import { padding } from "@mui/system";

///////////TABLA
const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border-radius: 0px;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }

  // DATEPICKER

  .css-i4bv87-MuiSvgIcon-root {
    position: absolute !important;
    top: -5px !important;
    left: -14px !important;
    font-size: 27px !important;
    color: black !important;
  }
`;

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;

  // console.log(filterValue);
  // console.log(preFilteredRows);
  // console.log(setFilter);
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        // console.log(e.target.value, 'e.target.value' );
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Buscar ${count} registros...`}
    />
  );
}

const defaultColumn = {
  Filter: DefaultColumnFilter,
};

function getExportFileBlob({ columns, data, fileType, fileName }) {
  if (fileType === "csv") {
    // CSV example
    const headerNames = columns.map((col) => col.exportValue);
    const csvString = Papa.unparse({ fields: headerNames, data });
    return new Blob([csvString], { type: "text/csv" });
  } else if (fileType === "xlsx") {
    // XLSX example

    // const header = columns.map((c) => c.exportValue);
    // const compatibleData = data.map((row) => {
    //   const obj = {};
    //   header.forEach((col, index) => {
    //     obj[col] = row[index];
    //   });
    //   return obj;
    // });

    // let wb = XLSX.utils.book_new();
    // let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
    //   header,
    // });
    // XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
    // XLSX.writeFile(wb, `${fileName}.xlsx`);

    // Returning false as downloading of file is already taken care of
    return false;
  }
  //PDF example
  if (fileType === "pdf") {
    const headerNames = columns.map((column) => column.exportValue);
    const doc = new JsPDF();
    doc.autoTable({
      head: [headerNames],
      body: data,
      margin: { top: 20 },
      styles: {
        minCellHeight: 9,
        halign: "left",
        valign: "center",
        fontSize: 11,
      },
    });
    doc.save(`${fileName}.pdf`);

    return false;
  }

  // Other formats goes here
  return false;
}

function Table({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    exportData,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      getExportFileBlob,
    },
    useFilters,
    useSortBy,
    useExportData,
  );

  //PAGINATION
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(10);
  };
  const [page, setPage] = React.useState(0); // originalmente 2
  const [rowsPerPage, setRowsPerPage] = React.useState(10); // originalmente 10
  //PAGINATION

  return (
    <>
      <div
        style={{
          margin: "auto",
          // display: 'inline-block',
          margin: "auto",
          textAlign: "center",
        }}
      >
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("csv", true);
          }}
        >
          Todo CSV
        </button>
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("csv", false);
          }}
        >
          CSV
        </button>
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("xlsx", true);
          }}
        >
          Todo xlsx
        </button>
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("xlsx", false);
          }}
        >
          xlsx
        </button>
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("pdf", true);
          }}
        >
          Todo PDF
        </button>{" "}
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("pdf", false);
          }}
        >
          PDF
        </button>
        <div className="mostrando">Mostrando {rows.length} resultados</div>
      </div>
      <hr
        style={{
          width: "65%",
          border: "1px solid black",
        }}
      ></hr>
      <div
        style={{
          overflowX: "auto",
        }}
      >
        <table {...getTableProps()} className="generalTableStyle">
          <thead>
            <button
              className="greenButton"
              style={{
                marginRight: "5px",
              }}
              onClick={() => {}}
            >
              Crear nuevo
            </button>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  // Add the sorting props to control sorting. For this example
                  // we can add them into the header props
                  <th {...column.getHeaderProps()} style={{ margin: "20px" }}>
                    {/* {console.log(column)} */}
                    <span {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                    </span>
                    <div>
                      {column.canFilter ? column.render("Filter") : null}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <br />
        <TablePagination
          component="div"
          count={10}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          style={{
            width: "80%",
            overflowX: "hidden" /* Hide vertical scrollbar */,
            overflowY: "hidden" /* Hide horizontal scrollbar */,
            textAlign: "right",
          }}
        />
      </div>
    </>
  );
}

///GENERAL STYLES
const { Title, Paragraph, Text } = Typography;

const InformePorUsuario = () => {
  // Styles
  //TABLA
  const columnsTable = React.useMemo(
    () => [
      {
        Header: `Contactos`,
        columns: [
          {
            Header: "Fecha",
            accessor: "fechaInfGen",
          },
          {
            Header: "Pte. Llamada",
            accessor: "pteLlamadaInfGen",
          },
          {
            Header: "Llamado",
            accessor: "llamadoInfGen",
          },
          {
            Header: "Cliente",
            accessor: "clienteInfGen",
          },
          {
            Header: "Cancelado",
            accessor: "canceladoInfGen",
          },
          {
            Header: "Total Contactos",
            accessor: "totalContactosInfGen",
          },
        ],
      },
    ],
    [],
  );

  const data = React.useMemo(() => makeData(10), []);
  //SELECT
  const handleChange = (event) => {
    // console.log(event, 'event');
    // console.log(event.target, 'event.target');
    // console.log(event.target.value, 'event.target.value');
    setName(event.target.value);
  };
  const [name, setName] = React.useState("");
  // SELECT
  // DATEPICKER
  const [dateInformePorUsuarioDesde, setDateInformePorUsuarioDesde] =
    React.useState(new Date());
  const [dateInformePorUsuarioHasta, setDateInformePorUsuarioHasta] =
    React.useState(new Date());
  // DATEPICKER

  return (
    <div className={"fatherContainer"}>
      <div className="viewHead">
        <h2 className={"title"}>Informes</h2>
        <Text className={"paragraph"}>
          <a href="/" style={{ textDecoration: "none", color: "black " }}>
            Inicio
          </a>{" "}
          / <b> Informes </b>
        </Text>
      </div>
      <div className={"mainContainer"}>
        <Text className={"titleSub"}>Seleccionar rango por fechas</Text>
        <Styles>
          <FormControl sx={{ m: 0, minWidth: 120 }} style={{ margin: "20px" }}>
            <InputLabel id="demo-simple-select-autowidth-label">
              Empresa
            </InputLabel>
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={name}
              onChange={handleChange}
              autoWidth
              label="Nombre"
            >
              <MenuItem value="">
                <em>Selecciona</em>
              </MenuItem>
              <MenuItem value={20}>Fidelitis</MenuItem>
              <MenuItem value={21}>Peritos Legales</MenuItem>
            </Select>
          </FormControl>
          <LocalizationProvider>
            <DateTimePicker
              renderInput={(props) => <TextField {...props} />}
              label="Desde"
              value={dateInformePorUsuarioDesde}
              onChange={(newValue) => {
                setDateInformePorUsuarioDesde(newValue);
              }}
            />
            <DateTimePicker
              renderInput={(props) => <TextField {...props} />}
              label="Hasta"
              value={dateInformePorUsuarioHasta}
              onChange={(newValue) => {
                setDateInformePorUsuarioHasta(newValue);
              }}
            />
          </LocalizationProvider>
        </Styles>
      </div>
      <div className={"mainContainer"}>
        <Text className={"titleSub"}>Expedientes por estado del flujo</Text>
        <p className={"secondItem"}>
          Lo sentimos, aún no hay datos para mostrar
        </p>
      </div>
      <div className={"mainContainer"}>
        <Text className={"titleSub"}>
          Expedientes asignados,actualizados y solicitudes
        </Text>
        <Grid container spacing={0} style={{ margin: "20px 0px 10px 0px" }}>
          <Grid
            item
            xs={3}
            style={{
              background: "rgba(220,220,220,0.5)",
              borderRadius: "10px",
              color: "black",
              padding: "3px",
              width: "22.5%",
            }}
          >
            Expedientes Asignados
          </Grid>
          <Grid
            item
            xs={3}
            style={{
              background: "rgba(26,179,148,0.5)",
              borderRadius: "10px",
              color: "black",
              padding: "3px",
              width: "22.5%",
            }}
          >
            Expedientes Actualizados
          </Grid>
          <Grid
            item
            xs={3}
            style={{
              background: "rgba(49,28,184,0.50)",
              borderRadius: "10px",
              color: "white",
              padding: "3px",
              width: "22.5%",
            }}
          >
            Tareas Actualizadas
          </Grid>
          <Grid
            item
            xs={3}
            style={{
              background: "rgba(179,26,83,0.50)",
              borderRadius: "10px",
              color: "white",
              padding: "3px",
              width: "22.5%",
            }}
          >
            Solicitudes realizadas
          </Grid>
        </Grid>
      </div>
      <div className={"mainContainer"}>
        <Text className={"titleSub"}>Expedientes por fecha de creación</Text>
        <p className={"secondItem"}>
          Lo sentimos, aún no hay datos para mostrar
        </p>
      </div>
      <div className={"mainContainer"}>
        <Text className={"titleSub"}>
          Expedientes por fecha de actualización
        </Text>
        <p className={"secondItem"}>
          Lo sentimos, aún no hay datos para mostrar
        </p>
      </div>
      {/* <button className={menuButton} className="greenButton" onClick={{}}>Editar</button>
            <button className={menuButton} className="whiteButton" onClick={{}}>Cambiar Contraseña</button> */}
    </div>
  );
};

export default InformePorUsuario;
